import { render, staticRenderFns } from "./InvoiceSearchBar.vue?vue&type=template&id=d4fc2cb8&"
import script from "./InvoiceSearchBar.vue?vue&type=script&lang=ts&"
export * from "./InvoiceSearchBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports